module.exports = __webpack_public_path__ + "static/media/proceso-01-agenda.d523be46.svg";